if(!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
        constructor() {
            super();

            this.overlay = this.querySelector("#image-slideshow-overlay");
            this.nextButton = this.querySelector('button[name="next"]');
            this.previousButton = this.querySelector('button[name="previous"]');
            this.closeButton = this.querySelector('button[name="close"]')
            this.totalMediaNumber = this.querySelectorAll(".zoomed-image-slide").length;
            this.currentMediaNumber = 0;
            this.boundKeydown = this.onKeydown.bind(this);
            this.numbersContainer = this.querySelector('.media-gallery-numbers')
            this.buttons = this.querySelector('.media-gallery-buttons')

            this.mobileSlider = this.querySelector('.image-slideshow-track');
            this.sliderScroller = this.sliderScroll.bind(this);  
            this.isScrolling;  

            if(this.totalMediaNumber > 0) {
                this.querySelectorAll('.product-thumbnail').forEach((thumbnail) => {
                    thumbnail.addEventListener('click', (e) => this.onThumbnailClick(e));
                })
                           
                this.closeButton.addEventListener('click', (e) => this.closeMediaGallery(e));               
            } 
            
            if(this.totalMediaNumber > 1){
                this.nextButton.addEventListener('click', (e) => this.onButtonClick(e, 1));
                this.previousButton.addEventListener('click', (e) => this.onButtonClick(e, -1));  

                if(window.matchMedia("(max-width: 991px)").matches){                   
                    this.setForMobile();
                    this.mobileSlider.addEventListener('scroll', this.sliderScroller)
                }
                
                window.addEventListener("resize",debounce(() => {               
                    if(window.matchMedia("(max-width: 991px)").matches){
                    this.setForMobile();
                    this.mobileSlider.removeEventListener('scroll', this.sliderScroller)
                    this.mobileSlider.addEventListener('scroll', this.sliderScroller)
                    }else{
                    this.mobileSlider.removeEventListener('scroll', this.sliderScroller)
                    this.setForDesktop();
                    }
                }));
            }
        }    
        
        sliderScroll(e){         
            let element = this.querySelector('.zoomed-image-slide')
            let gap = (document.querySelector('body').offsetWidth - element.offsetWidth) / 2
            let middle = this.mobileSlider.scrollLeft + ( document.querySelector('body').offsetWidth / 2) - gap
            this.querySelectorAll(".zoomed-image-slide").forEach((slide) => {
                let elStart = slide.offsetLeft - gap;
                let elEnd = slide.offsetLeft + slide.offsetWidth + gap;
                if(elStart <= middle && middle <= elEnd)
                {
                    this.currentMediaNumber = parseInt(slide.dataset.mediaNumber);
                    this.onButtonClick(e, 0, true)
                }
            })                 
        }


        onThumbnailClick(e){       
            this.removeTabindexFromDeferredMedia();
            document.addEventListener('keydown', this.boundKeydown)
            this.overlay.style.cssText = 'display: flex; flex-direction: column; justify-content: center; opacity: 0%;'
            this.overlay.style.animation = 'opacityAnimation .3s ease-in-out forwards';
            this.currentMediaNumber = parseInt(e.currentTarget.dataset.mediaNumber);
            this.querySelector('.image-slideshow-track').scrollLeft = window.innerWidth * this.currentMediaNumber;
            this.getElementsByClassName("zoomed-image-slide")[this.currentMediaNumber].setAttribute("aria-hidden", false);
            this.checkArrowButtons();
            this.overlay.setAttribute("aria-hidden", false)
        }

        onButtonClick(e, number, skipScroll = false){     
            this.removeTabindexFromDeferredMedia();

            this.getElementsByClassName("zoomed-image-slide")[this.currentMediaNumber].setAttribute("aria-hidden", true);
            
            if(window.matchMedia("(max-width: 991px)").matches){
                this.numbersContainer.innerHTML = (this.currentMediaNumber + 1) + "/" + this.totalMediaNumber;
            }
            
            this.getElementsByClassName("zoomed-image-slide")[this.currentMediaNumber + number].setAttribute("aria-hidden", false);

            if(!skipScroll){
                let scroll = 'auto';
                window.matchMedia("(max-width: 991px)").matches ? scroll = 'smooth' : scroll = 'auto'  
                this.querySelector('.image-slideshow-track').scrollTo({ left: document.body.clientWidth * (this.currentMediaNumber + number), behavior: scroll })
            } 
            
            if(window.matchMedia("(min-width: 992px)").matches){
                this.currentMediaNumber = this.currentMediaNumber + number;
            }
        
            this.checkArrowButtons(); 
            window.pauseAllMedia();             
        }

        checkArrowButtons(){
            this.addTabindexToDeferredMedia();

            if(this.previousButton) this.currentMediaNumber == 0 ? this.previousButton.disabled = true : this.previousButton.disabled = false;
            if(this.nextButton) this.currentMediaNumber == (this.totalMediaNumber - 1) ? this.nextButton.disabled = true : this.nextButton.disabled = false; 

            if(window.matchMedia("(min-width: 992px)").matches){                          
                var activeElement = document.activeElement;
                
                if(activeElement != this.nextButton || activeElement != this.previousButton){
                    if(this.currentMediaNumber == 0){
                        activeElement = this.nextButton
                    }else{
                        activeElement = this.previousButton
                    }
                }               
                trapFocus(this.overlay, activeElement);
            }   
        }

        onKeydown(e){
            if(e.type == "keydown"){
                if(e.code == "ArrowRight" && this.currentMediaNumber != (this.totalMediaNumber - 1)) {
                    this.onButtonClick(e, 1)
                }else if(e.code == "ArrowLeft" && this.currentMediaNumber != 0){
                    this.onButtonClick(e, -1)
                }else if (e.code == "Escape"){
                    this.closeMediaGallery(e);
                }
            }
        }

        closeMediaGallery(e) {
            pauseAllMedia();
            this.overlay.style.animation = 'loseOpacityAnimation .3s ease-in-out forwards';
            setTimeout(() => {
                this.overlay.style.cssText = 'display: none;'
            }, 300);           
            document.removeEventListener('keydown', this.boundKeydown)
            this.overlay.setAttribute("aria-hidden", true)
            this.getElementsByClassName("zoomed-image-slide")[this.currentMediaNumber].setAttribute("aria-hidden", true);         
        }

        setForMobile() {       
            this.getElementsByClassName("zoomed-image-slide")[this.currentMediaNumber].setAttribute("aria-hidden", false);
            this.querySelector('.image-slideshow-track').scrollLeft = window.innerWidth * this.currentMediaNumber;
            this.numbersContainer.innerHTML = (this.currentMediaNumber + 1) + "/" + this.totalMediaNumber;
            if (this.previousButton) this.previousButton.disabled = false;
            if (this.nextButton) this.nextButton.disabled = false;
            this.checkArrowButtons();
            this.overlay.setAttribute("aria-hidden", false)
            this.querySelectorAll('.product-thumbnail').forEach((thumbnail) => {
                thumbnail.style.pointerEvents = "none"
            })
        }

        setForDesktop() {
            //this.closeMediaGallery();
            this.overlay.setAttribute("aria-hidden", true)
            this.querySelectorAll('.product-thumbnail').forEach((thumbnail) => {
                thumbnail.style.pointerEvents = "unset"
            })
        }

        removeTabindexFromDeferredMedia(){
            this.querySelectorAll('[id^="Deferred-Poster-"], video, iframe').forEach(el => {
                el.setAttribute('tabindex', -1)
            })
        }

        addTabindexToDeferredMedia(){
            var mediaBtn = this.getElementsByClassName("zoomed-image-slide")[this.currentMediaNumber].querySelector('[id^="Deferred-Poster-"]')          
            if(mediaBtn){
                //mediaBtn.click();
                mediaBtn.removeAttribute('tabindex')
                var video = this.getElementsByClassName("zoomed-image-slide")[this.currentMediaNumber].querySelectorAll('video, iframe')[0]
                if(video){
                    video.removeAttribute('tabindex')
                }              
            }
        }
    })
}